export type UserLanguage = 'en' | 'de';

// TODO: move to another directory.
export class DecimalFormatConverter {
  private static readonly NUMBER_FORMAT = '/(d)(?=(d{3})+(?!d))/g';

  public constructor(private readonly userLanguage: UserLanguage) {}

  // Return val with 2 decimals
  public transformByGivenSeparator(value: number): any {
    const decimalSeparator = this.userLanguage.startsWith('en') ? '.' : ',';
    const defSep = '.';
    return value == null ? '' : value.toFixed(2).toString().replace(defSep, decimalSeparator);
  }

  public numberFormatterByLocalLang(value: number): string {
    return value == null ? '' : new Intl.NumberFormat(this.userLanguage).format(value);
  }

  public numberCurrencyFormatterByLocalLang(value: number, currencyInput: string): string {
    return value === null
      ? ''
      : new Intl.NumberFormat(this.userLanguage, {
          style: 'currency',
          currency: currencyInput, //"EUR","USD"...
        }).format(value);
  }

  public numberFormatterWithSeparators(amount: number, decimalPlacesMin?: number, decimalPlacesMax?: number): any {
    return new Intl.NumberFormat(this.userLanguage, {
      minimumFractionDigits: decimalPlacesMin,
      maximumFractionDigits: decimalPlacesMax,
    }).format(Math.round(amount * 100) / 100);
  }

  public reverseNumberFormatterWithSeparators(value: string): number {
    const group = new Intl.NumberFormat(this.userLanguage).format(1111).replaceAll('1', '');
    const decimal = new Intl.NumberFormat(this.userLanguage).format(1.1).replaceAll('1', '');
    let reversedVal = value.replaceAll(new RegExp(`\\${group}`, 'g'), '');
    reversedVal = reversedVal.replaceAll(new RegExp(`\\${decimal}`, 'g'), '.');
    return Number.isNaN(Number(reversedVal)) ? 0 : Number(reversedVal);
  }

  //"#,##0.00"
  public formatNumberCommaAfterEvery3Numbers(num: number): string {
    return num.toString().replaceAll(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }

  //"#.##0,00"
  public formatNumberDotAfterEvery3Numbers(num: number): string {
    return num.toString().replaceAll(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
  }

  public formatWith2DecimalPlaces(amount: string): any {
    return Number(amount).toFixed(2);
  }
}
